"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitAdditionalScreen = exports.onFaceTecSDKInitializationFailure = exports.onFaceTecSDKInitializationSuccess = void 0;
const AdditionalScreens_1 = require("../../facetec/src/utilities/AdditionalScreens");
const DeveloperStatusMessages_1 = require("../../facetec/src/utilities/DeveloperStatusMessages");
const SampleAppUtilities_1 = require("../../facetec/src/utilities/SampleAppUtilities");
const ThemeHelpers_1 = require("../../facetec/src/utilities/ThemeHelpers");
const onFaceTecSDKInitializationSuccess = () => {
    SampleAppUtilities_1.SampleAppUtilities.enableControlButtons();
    // Set your FaceTec Device SDK Customizations.
    ThemeHelpers_1.ThemeHelpers.setAppTheme(ThemeHelpers_1.ThemeHelpers.getCurrentTheme());
    // Set the sound files that are to be used for Vocal Guidance.
    SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceSoundFiles();
    // Set the strings to be used for group names, field names, and placeholder texts for the FaceTec ID Scan User OCR Confirmation Screen.
    SampleAppUtilities_1.SampleAppUtilities.setOCRLocalization();
    if (document.getElementById("controls") !== null) {
        AdditionalScreens_1.AdditionalScreens.setServerUpgradeStyling(document.getElementById("controls"), exports.exitAdditionalScreen);
    }
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
};
exports.onFaceTecSDKInitializationSuccess = onFaceTecSDKInitializationSuccess;
const onFaceTecSDKInitializationFailure = () => {
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
};
exports.onFaceTecSDKInitializationFailure = onFaceTecSDKInitializationFailure;
const exitAdditionalScreen = () => {
    AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
};
exports.exitAdditionalScreen = exitAdditionalScreen;
